module.exports = __webpack_public_path__ + "static/media/05.335c64ed.jpg";